import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

// Shared Layout Components

import { SiteHeaderComponent } from "src/app/_ibtc/components/site-header/site-header.component";
import { SiteFooterComponent } from "src/app/_ibtc/components/site-footer/site-footer.component";
import { SecondaryFooterComponent } from "src/app/_ibtc/components/secondary-footer/secondary-footer.component";
import { PostItemComponent } from "src/app/_ibtc/components/post-item/post-item.component";
import { SwiperQuoteComponent } from "src/app/_ibtc/components/swiper-quote/swiper-quote.component";
import { SearchComponent } from "src/app/_ibtc/components/search/search.component";
import { MobileSearchComponent } from "src/app/_ibtc/components/mobile-search/mobile-search.component";

// Shared Material Modules

import { MatExpansionModule } from "@angular/material/expansion";
import { MatDialogModule } from "@angular/material/dialog";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';

// Shared Forms Module

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SwiperModule } from "swiper/angular";
import { SwiperSkillsComponent } from "src/app/_ibtc/components/swiper-skills/swiper-skills.component";
import { SwiperWhyStudyComponent } from "src/app/_ibtc/components/swiper-why-study/swiper-why-study.component";
import { SwiperReadingResourcesComponent } from "src/app/_ibtc/components/swiper-reading-resources/swiper-reading-resources.component";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { SwiperWaysStudyComponent } from "src/app/_ibtc/components/swiper-ways-study/swiper-ways-study.component";
import { SwiperInstitutesQualificationComponent } from "src/app/_ibtc/components/swiper-institutes-qualification/swiper-institutes-qualification.component";
import { TwoColumnMediaLeftComponent } from "src/app/_ibtc/components/page-builder/layouts/two-column-media-left/two-column-media-left.component";
import { TwoColumnMediaRightComponent } from "src/app/_ibtc/components/page-builder/layouts/two-column-media-right/two-column-media-right.component";
import { OneColumnTitleComponent } from "src/app/_ibtc/components/page-builder/headers/one-column-title/one-column-title.component";
import { OneColumnTitleSubtitleComponent } from "src/app/_ibtc/components/page-builder/headers/one-column-title-subtitle/one-column-title-subtitle.component";
import { FooterOneColumnTitleButtonComponent } from "../../../_ibtc/components/page-builder/footer/footer-one-column-title-button/footer-one-column-title-button.component";
import { SafeHtmlPipe } from "src/app/pipes/safe-html.pipe";
import { StripHtmlPipe } from "src/app/pipes/strip-html.pipe";
import { NestedEllipsisModule } from 'ngx-nested-ellipsis';

// Page Builder Components

import { PbHeaderGeneralComponent } from "src/app/_ibtc/components/page-builder/pb-header-general/pb-header-general.component";
import { PbReadingResourcesSummaryComponent } from "src/app/_ibtc/components/page-builder/pb-reading-resources-summary/pb-reading-resources-summary.component";
import { PbTestimonialsComponent } from "src/app/_ibtc/components/page-builder/pb-testimonials/pb-testimonials.component";
import { PbDividerTextLeftComponent } from "src/app/_ibtc/components/page-builder/pb-divider-text-left/pb-divider-text-left.component";
import { PbDividerTextCenterComponent } from "src/app/_ibtc/components/page-builder/pb-divider-text-center/pb-divider-text-center.component";
import { PbDividerTextRightComponent } from "src/app/_ibtc/components/page-builder/pb-divider-text-right/pb-divider-text-right.component";
import { PbWysiwygComponent } from "src/app/_ibtc/components/page-builder/pb-wysiwyg/pb-wysiwyg.component";
import { PbInstituteListingComponent } from "src/app/_ibtc/components/page-builder/pb-institute-listing/pb-institute-listing.component";
import { PbTeamMemberComponent } from "src/app/_ibtc/components/page-builder/pb-team-member/pb-team-member.component";
import { PbMapComponent } from "src/app/_ibtc/components/page-builder/pb-map/pb-map.component";
import { PbGalleryComponent } from "src/app/_ibtc/components/page-builder/pb-gallery/pb-gallery.component";
import { PbContactFormComponent } from "src/app/_ibtc/components/page-builder/pb-contact-form/pb-contact-form.component";
import { PbInstituteLevelBreakdownComponent } from "src/app/_ibtc/components/page-builder/pb-institute-level-breakdown/pb-institute-level-breakdown.component";
import { PbInstituteHeaderComponent } from "../../../_ibtc/components/page-builder/pb-institute-header/pb-institute-header.component";
import { PbFaqsComponent } from "src/app/_ibtc/components/page-builder/pb-faqs/pb-faqs.component";
import { PbInstitutePriceComparisonComponent } from "src/app/_ibtc/components/page-builder/pb-institute-price-comparison/pb-institute-price-comparison.component";
import { PbPromotionSingleComponent } from "src/app/_ibtc/components/page-builder/pb-promotion-single/pb-promotion-single.component";
import { PbTutorSupportFormComponent } from "src/app/_ibtc/components/page-builder/pb-tutor-support-form/pb-tutor-support-form.component";
import { PbValueAddFormComponent } from "src/app/_ibtc/components/page-builder/pb-value-add-form/pb-value-add-form.component";
import { PbHeaderHomeComponent } from "src/app/_ibtc/components/page-builder/pb-header-home/pb-header-home.component";
import { PbExamCounterComponent } from "src/app/_ibtc/components/page-builder/pb-exam-counter/pb-exam-counter.component";
import { PbDividerTextNoneComponent } from "src/app/_ibtc/components/page-builder/pb-divider-text-none/pb-divider-text-none.component";
import { PbTestimonialsCustomComponent } from "src/app/_ibtc/components/page-builder/pb-testimonials-custom/pb-testimonials-custom.component";
import { PbStudyOptionsComponent } from "src/app/_ibtc/components/page-builder/pb-study-options/pb-study-options.component";
import { PbContentCardsComponent } from "src/app/_ibtc/components/page-builder/pb-content-cards/pb-content-cards.component";
import { PbProgressComponent } from "src/app/_ibtc/components/page-builder/pb-progress/pb-progress.component";
import { PbEventComponent } from "src/app/_ibtc/components/page-builder/pb-event/pb-event.component";
import { PbLinkArrowLeftComponent } from "src/app/_ibtc/components/page-builder/pb-link-arrow-left/pb-link-arrow-left.component";
import { PbLinkArrowNoneComponent } from "src/app/_ibtc/components/page-builder/pb-link-arrow-none/pb-link-arrow-none.component";
import { PbLinkArrowRightComponent } from "src/app/_ibtc/components/page-builder/pb-link-arrow-right/pb-link-arrow-right.component";
import { PbFooterSecondaryComponent } from "src/app/_ibtc/components/page-builder/pb-footer-secondary/pb-footer-secondary.component";
import { PbPromotionsSliderComponent } from "src/app/_ibtc/components/page-builder/pb-promotions-slider/pb-promotions-slider.component";
import { PbProgressCustomComponent } from "src/app/_ibtc/components/page-builder/pb-progress-custom/pb-progress-custom.component";
import { PbCodeComponent } from "src/app/_ibtc/components/page-builder/pb-code/pb-code.component";
import { PbLeadGenFormComponent } from "src/app/_ibtc/components/page-builder/pb-lead-gen-form/pb-lead-gen-form.component";
import { PbEventApplicationFormComponent } from "src/app/_ibtc/components/page-builder/pb-event-application-form/pb-event-application-form.component";
import { PbContainerComponent } from "src/app/_ibtc/components/page-builder/pb-container/pb-container.component";
import { PbHeaderNoticeBoardComponent } from "src/app/_ibtc/components/page-builder/pb-header-notice-board/pb-header-notice-board.component";

@NgModule({
  declarations: [
    SiteHeaderComponent,
    SiteFooterComponent,
    SecondaryFooterComponent,
    PostItemComponent,
    SwiperQuoteComponent,
    SearchComponent,
    MobileSearchComponent,
    SwiperSkillsComponent,
    SwiperWhyStudyComponent,
    SwiperReadingResourcesComponent,
    SwiperWaysStudyComponent,
    SwiperInstitutesQualificationComponent,
    TwoColumnMediaLeftComponent,
    TwoColumnMediaRightComponent,
    OneColumnTitleComponent,
    OneColumnTitleSubtitleComponent,
    FooterOneColumnTitleButtonComponent,
    PbHeaderNoticeBoardComponent,
    PbHeaderGeneralComponent,
    PbReadingResourcesSummaryComponent,
    PbTestimonialsComponent,
    PbDividerTextLeftComponent,
    PbDividerTextCenterComponent,
    PbDividerTextRightComponent,
    PbWysiwygComponent,
    PbInstituteListingComponent,
    PbTeamMemberComponent,
    PbMapComponent,
    PbGalleryComponent,
    PbContactFormComponent,
    PbTutorSupportFormComponent,
    PbValueAddFormComponent,
    PbInstituteLevelBreakdownComponent,
    PbInstituteHeaderComponent,
    PbFaqsComponent,
    PbInstitutePriceComparisonComponent,
    PbPromotionSingleComponent,
    PbHeaderHomeComponent,
    PbExamCounterComponent,
    PbDividerTextNoneComponent,
    PbTestimonialsCustomComponent,
    PbStudyOptionsComponent,
    PbContentCardsComponent,
    PbProgressComponent,
    PbEventComponent,
    PbLinkArrowLeftComponent,
    PbLinkArrowNoneComponent,
    PbLinkArrowRightComponent,
    PbFooterSecondaryComponent,
    PbPromotionsSliderComponent,
    PbProgressCustomComponent,
    PbCodeComponent,
    PbLeadGenFormComponent,
    PbEventApplicationFormComponent,
    PbContainerComponent,
    SafeHtmlPipe,
    StripHtmlPipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatExpansionModule,
    MatDialogModule,
    MatCheckboxModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatTooltipModule,
    MatSnackBarModule,
    SwiperModule,
    NgxSkeletonLoaderModule,
    NestedEllipsisModule
  ],
  exports: [
    SiteHeaderComponent,
    SiteFooterComponent,
    SecondaryFooterComponent,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatMenuModule,
    MatSelectModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    PostItemComponent,
    SwiperQuoteComponent,
    SearchComponent,
    MobileSearchComponent,
    SwiperSkillsComponent,
    SwiperWhyStudyComponent,
    SwiperReadingResourcesComponent,
    SwiperWaysStudyComponent,
    SwiperInstitutesQualificationComponent,
    MatIconModule,
    TwoColumnMediaLeftComponent,
    TwoColumnMediaRightComponent,
    OneColumnTitleComponent,
    OneColumnTitleSubtitleComponent,
    FooterOneColumnTitleButtonComponent,
    PbHeaderNoticeBoardComponent,
    PbHeaderGeneralComponent,
    PbReadingResourcesSummaryComponent,
    PbTestimonialsComponent,
    PbDividerTextLeftComponent,
    PbDividerTextCenterComponent,
    PbDividerTextRightComponent,
    PbWysiwygComponent,
    PbInstituteListingComponent,
    PbTeamMemberComponent,
    PbMapComponent,
    PbGalleryComponent,
    PbContactFormComponent,
    PbTutorSupportFormComponent,
    PbValueAddFormComponent,
    PbInstituteLevelBreakdownComponent,
    PbInstituteHeaderComponent,
    PbFaqsComponent,
    PbInstitutePriceComparisonComponent,
    PbPromotionSingleComponent,
    PbHeaderHomeComponent,
    PbExamCounterComponent,
    PbDividerTextNoneComponent,
    PbTestimonialsCustomComponent,
    PbStudyOptionsComponent,
    PbContentCardsComponent,
    PbProgressComponent,
    PbEventComponent,
    PbLinkArrowLeftComponent,
    PbLinkArrowNoneComponent,
    PbLinkArrowRightComponent,
    PbFooterSecondaryComponent,
    PbPromotionsSliderComponent,
    PbProgressCustomComponent,
    PbCodeComponent,
    PbLeadGenFormComponent,
    PbEventApplicationFormComponent,
    PbContainerComponent,
    SafeHtmlPipe,
    StripHtmlPipe,
  ],
})
export class SharedModule { }
